export default __webpack_public_path__ + "9461026f1fe6157fcfc7fb3e7320bd72.svg";